import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Product } from 'core/types/api/Api';
import { useManagerProfile } from 'prodivers/managerProfile';
import arrayContains from 'utils/arrayUtils';
import { ACCESS_POLICY, PRODUCTS } from '../constants/constants';
import { useGetCustomService } from './rest/useGetCustomService';

export const threeBProductGroup = {
    id: 999999,
    name: '3b',
    description: 'Zurich Invest 3b',
    isEnabled: true,
    settings: { productKey: '3b' },
};

export const useProductsList = (contactId?:number, enabled: boolean = true, isMortgageEnabled: boolean = true) => {
    const { i18n: { language } } = useTranslation();
    const { hasAccessPolicy } = useManagerProfile();

    const {
        data,
        isLoading: isLoadingProducts,
        error: errorProducts,
    } = useGetCustomService({
        service: 'customCommonService',
        api: 'getProductsConfiguration',
        payload: { language, contactId },
        enabled,
        staleTime: 60 * 60 * 1000,
        gcTime: 2 * 60 * 60 * 1000,
    });

    const configurationData = data?.data;

    const products: Product[] = useMemo(() => {
        if (configurationData?.productOffers?.length) {
            return configurationData.productOffers[0].products;
        }

        return [];
    }, [configurationData]);

    const groupedProducts: Product[] = useMemo(() => {
        if (!configurationData?.productOffers?.length) return [];

        const groupedProds: any[] = configurationData.productOffers[0].products?.filter(
            (f: any) => (f.settings?.productKey !== PRODUCTS.bbb) && (f.externalId !== 'AZP alt') && f?.isEnabled,
        );

        if (configurationData.productOffers[0].products.some((s: any) => s.settings.productKey === PRODUCTS.bbb && s.isEnabled)) {
            groupedProds.push(threeBProductGroup);
        }

        const show3ap = hasAccessPolicy(ACCESS_POLICY.Product3aPremium);
        const showMortgage = hasAccessPolicy(ACCESS_POLICY.ProductMortgage) && isMortgageEnabled;

        return groupedProds?.filter((product: Product) => (show3ap || !arrayContains([PRODUCTS.aaap], product?.settings?.productKey))
            && (showMortgage || !arrayContains([PRODUCTS.mortgage], product?.settings?.productKey)));
    }, [configurationData, hasAccessPolicy, isMortgageEnabled]);

    return {
        products,
        groupedProducts,
        isLoadingProducts,
        errorProducts,
    };
};
